<script setup lang="ts">

defineOptions({
  name: 'ScreenContainer',
})

interface ScreenContainerProps {
  bannerPosition?: 'top' | 'bottom',
  boxView?: 'default' | 'white'
}
withDefaults(defineProps<ScreenContainerProps>(), {
  bannerPosition: 'top',
  boxView: 'default',
})
</script>

<template>
  <div :class="['screen-container', bannerPosition, { 'padded': !$slots.bottom }]">
    <div
      v-if="$slots.default"
      :class="['screen-container__box', bannerPosition, boxView]"
    >
      <slot />
    </div>
    <div
      v-if="$slots.submit"
      :class="['screen-container__submit', { 'fly': !$slots.bottom }]"
    >
      <slot name="submit" />
    </div>
    <div
      v-if="$slots.bottom"
      class="screen-container__bottom"
    >
      <slot name="bottom" />
    </div>
  </div>
</template>

<style lang="scss" src="@scss/layouts/ScreenContainer.scss" />
